import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-ink py-20 md:py-28" aria-labelledby="realidad-title" data-id="element-113" data-mp="2lm0v5d9i1cv3">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-114" data-mp="26xehdfzist5z">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-20" data-id="element-115" data-mp="2bxix33sltjv5">
          <div data-id="element-116" data-mp="1xxreepr57fat">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent" data-id="element-117" data-mp="1xx8702z4c9b1">
              La realidad de todos los días
            </p>
            <h2 id="realidad-title" className="mt-4 text-4xl font-extrabold tracking-tightest text-white md:text-5xl" data-id="element-118" data-mp="220o22uvji1lm">
              ¿Te suena conocido?
            </h2>
            <p className="mt-6 max-w-sm text-lg leading-relaxed text-white/60" data-id="element-119" data-mp="1t0r8ceuamcjp">
              Cinco escenas que se repiten en el consultorio de casi todos los kinesiólogos del
              país.
            </p>
          </div>

          <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-120" data-mp="1z0f2n3p1vmal">
            {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-5" data-id="element-121" data-mp="1u2dh8c45javy">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/10" data-id="element-122" data-mp="27sqpygovatmc">
                  <XIcon className="h-3.5 w-3.5 text-white/70" strokeWidth={3} data-id="element-123" data-mp="1g1syffy8lf2g" />
                </span>
                <p className="text-base leading-relaxed text-white/85 md:text-lg" data-id="element-124" data-mp="1b2pu5xq2zcvj">{point}</p>
              </li>)}
          </ul>
        </div>

        <p className="mt-14 max-w-2xl text-2xl font-bold leading-snug tracking-tight text-white md:text-3xl" data-id="element-125" data-mp="1p3afb0jgxks7">
          No es falta de conocimiento.{' '}
          <span className="text-accent" data-id="element-126" data-mp="30he65xurest1">Es falta de un sistema.</span>
        </p>
      </div>
    </section>;
}